import ThisModule from "./ModalPleaseWait";

export default ThisModule;
